var map = {
	"./1.jpg": 360,
	"./2.jpg": 361,
	"./3.jpg": 362,
	"./4.jpg": 363,
	"./5.jpg": 364,
	"./6.jpg": 365,
	"./7.jpg": 366,
	"./8.jpg": 367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73;